import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API } from './api.config';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  private readonly versionSubject = new BehaviorSubject<string>('...');
  readonly version$ = this.versionSubject.asObservable();
  private baseUrl = environment.api;

  constructor(private http: HttpClient) {}

  setVersion(version: string): void {
    this.versionSubject.next(version);
  }

  getAppVersions(): Observable<any> {
    const headers = new HttpHeaders({
      'channelId': '20',
      'accept-language': 'es'
    });

    const apiUrl = `${this.baseUrl}${API.dipmal}${API.appVersions}`;
    return this.http.get(apiUrl, { headers });
  }
}